export enum AccessLevel {
    Public = 'Public',
    SelectiveSharing = 'SelectiveSharing',
    OrganisationLevel = 'OrganisationLevel',
}

export const AccessLevelsOptions = {
    [AccessLevel.SelectiveSharing]: 'Authorized Access',
    [AccessLevel.Public]: 'Public Access',
};

export const AccessLevelsExtensiveOptions = {
    [AccessLevel.SelectiveSharing]:
        'Authorized Access (Selected external / third-party organisations can access, depending on the applicable access policies)', // TODO: hide for now
    [AccessLevel.Public]: 'Public Access (All users can access)',
};
